import { register } from "async-ops";
import { callMvcApi } from "../../../../../call-web-api";
import { getDefaultOptions } from "../../../../../utils/fetch";

export const APPLY_ROUND_OUTCOME_TASK_CLEANUP = "APPLY_ROUND_OUTCOME_TASK_CLEANUP";

export interface ApplyRoundOutcomeTaskCleanupParams {
  eaCaseId: number;
  eaRoundId: number;
  newOutcomeId: number;
}

export const service = async (params: ApplyRoundOutcomeTaskCleanupParams) => {
  const options: object = {
    url: `/Api/EaCaseApiController/ApplyRoundOutcomeTaskCleanup`,
    method: "POST",
    body: JSON.stringify(params),
    ...getDefaultOptions(),
  };
  return callMvcApi(options);
};

const mock = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ isSaved: true });
    }, 500);
  });
};

register(APPLY_ROUND_OUTCOME_TASK_CLEANUP, service, mock);
